import React from 'react';
import { Link } from 'react-router-dom';
import { useMe } from '@/context/MeContext';

export default function AccountStatus() {
  const { me, loading } = useMe();

  if (loading) {
    return <div className="panel">Loading account status…</div>;
  }

  const status = me?.status ?? 'unknown';

  return (
    <div className="panel">
      <h1>Account status</h1>
      {status === 'pending_approval' ? (
        <>
          <p>Your registration was received and is waiting for administrator approval.</p>
          <p className="muted">You will be able to use Scoutly after an owner approves your account.</p>
        </>
      ) : status === 'rejected' ? (
        <p>Your registration was rejected. Contact support if you believe this is an error.</p>
      ) : status === 'disabled' ? (
        <p>Your account is disabled. Contact an administrator to restore access.</p>
      ) : status === 'unknown' ? (
        <p className="muted">
          You are not signed in, so Scoutly cannot display your account status. Please sign in.
        </p>
      ) : (
        <p>Your account is active.</p>
      )}
      {status === 'approved' ? (
        <Link className="btn btn-primary" to="/">
          Go to dashboard
        </Link>
      ) : (
        <Link className="btn btn-ghost" to="/login">
          Back to sign in
        </Link>
      )}
    </div>
  );
}
